import gql from 'graphql-tag'

const listApaleoProperties = gql`
	query listApaleoProperties{
	  cashAssist {
	    listApaleoProperties {
				id
	      name
	    }
	  }
	}
`

export default listApaleoProperties
